// extracted by mini-css-extract-plugin
module.exports = {"regional":"Regional_regional__XAMSQ"};